export default {
  form: {
    fullName: 'Full name',
    jobTitle: 'Job title',
    company1: 'ibis hotels/Styles/budget 1 - Company name',
    address1: 'ibis hotels/Styles/budget 1 - Address',
    company2: 'ibis hotels/Styles/budget 2 - Company name',
    address2: 'ibis hotels/Styles/budget 2 - Address',
    email: 'Email',
    phone: 'Phone',
    fax: 'Fax',
    operatingCompanyName: 'Operating company name',
    operatingCompanyInfos: 'Operating company infos',
    operatingCompanyDirectors: 'Managing directors',
    operatingCompanyVat: 'VAT ID number',
    facebookLink: 'Facebook Link',
    instagramLink: 'Instagram Link'
  },
  addNewField: 'Add new field',
  editField: 'Edit field',
  uploadImageDescription:
        'You can upload image or add the public link to image.'
}
